<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard>
          <OpexFormulario
            :idTipoOpex="idTipoOpex"
            :tipoOpex="tipoOpex"
            :nombreTipoOpex="nombreTipoOpex"
            :viewVersions="1"
          >
          </OpexFormulario>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'OpexPackingFormVerVersiones',
  components: {
    OpexFormulario: () => import('../../components/OpexFormulario')
  },
  data: () => ({
    title: 'VISUALIZAR VERSIÓN OPEX PACKING',
    page: {
      title: 'Visualizar Versión OPEX Packing'
    },
    breadcrumbs: [
      {
        text: 'Presupuesto',
        disabled: true
      },
      {
        text: 'OPEX Packing',
        disabled: true
      },
      {
        text: 'Visualizar Versión',
        disabled: false
      }
    ],
    idTipoOpex: 2,
    tipoOpex: 'pack',
    nombreTipoOpex: 'Packing'
  }),
  methods: {
    open() {},
    close() {}
  },
  created() {}
};
</script>
